<template>
  <div class="full-wrapper">
    <el-scrollbar :ref="scrollbarRef">
      <div class="full">
        <el-row class="title-bar" type="flex" justify="space-between">
          <div class="title-h3">보고서 이력</div>
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </el-row>
        <el-table-wrapper ref="histTable" :data="reportHistData" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;"
          :total="total" :column-default="columnDefault" remote pagination @condition-change="onTableConditionChange">
          <template slot-scope="scope" slot="slot">
            <span v-if="scope.row.successFlag === 'Y'" style="color: #1c53ca;">성공</span>
            <span v-else style="color: red;">실패</span>
          </template>
          <template slot-scope="scope" slot="downloadSlot">
            <span v-if="scope.row.successFlag === 'Y'" @click="downloadReport(scope.row)"><i class="far fa-arrow-to-bottom c-pointer"></i></span>
            <span v-else>-</span>
          </template>
        </el-table-wrapper>
      </div>
    </el-scrollbar>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import reportApi from '@/api/report/report';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';

const successFlagFilters = [{ text: '성공', value: 'Y' }, { text: '실패', value: 'N' }];
const reportCreateTypeFilters = [{ text: '수동', value: 'MANUAL' }, { text: '자동', value: 'AUTO' }];

export default {
  name: 'WReportHistTable',
  mixins: [ScrollbarMixin],
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
    activeTab: {
      // TODO 삭제필요
      type: String,
      default: () => 'list',
    },
  },
  data() {
    return {
      showSearchTool: false,
      reportHistData: [],
      columnDefault,
      total: null,
      columns: [
        { prop: 'successFlag', label: '성공여부', width: '100px', scopedSlot: 'slot', filterMultiple: false, filters: successFlagFilters, remoteProp: 'success_flag' },
        { prop: 'reportName', label: '보고서명', sortable: true, searchable: true, remoteProp: 'report_name' },
        { prop: 'reportCreateType', label: '출력 유형', width: '100px', formatter: this.getReportCreateType, remoteProp: 'report_create_type', filterMultiple: false, filters: reportCreateTypeFilters },
        { prop: 'checkDatetime', label: '출력일시', width: '180px', sortable: true, searchable: true, searchType: 'date', formatter: this.convertDatetime, remoteProp: 'check_datetime' },
        { label: '다운로드', width: '70px', align: 'center', scopedSlot: 'downloadSlot' },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
    },
    activeTab: {
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    loadData() {
      if (this.activeTab === 'hist') {
        const tableParams = this.$refs.histTable.getParameter();
        const params = {
          reportTmplId: this.selectedNode.reportTmplId,
          ...tableParams,
        };
        reportApi.getReportHist(params).then((response) => {
          if (response.data.success) {
            this.total = response.data.total;
            this.reportHistData = response.data.data;
          }
        });
      }
    },
    convertDatetime(row, column, value) {
      return getDateToString(value);
    },
    getReportCreateType(row, column, value) {
      return value === 'MANUAL' ? '수동' : '자동';
    },
    downloadReport(report) {
      const params = {
        seqNumber: report.seqNumber,
        managerId: report.managerId,
      };

      reportApi.existsReport(params).then((response) => {
        if (response.data.success) {
          reportApi.downloadReport({
            seqNumber: report.seqNumber,
            managerId: report.managerId,
          });
        } else {
          this.$message.error('해당 보고서가 생성되어있지 않습니다.');
        }
      });
    },
    onTableConditionChange() {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/template/hist/index.vue